import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { RegisterService } from '../proxy/planning/controllers/register.service';
import { PropertyService } from '../proxy/planning/controllers/property.service';

FieldBuilder.setNamespace('Planning');

export const REGISTERPERPROPERTY_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .foreignKey('registerId', 'Entity.Register', RegisterService)
    .required()
    .displayFromNested('register.name')
    .sortBy('register.name')
    .build(),
  FieldBuilder
    .foreignKey('propertyId', 'Entity.Property', PropertyService)
    .required()
    .displayFromNested('property.name')
    .sortBy('property.name')
    .build(),
];

export const REGISTERPERPROPERTY_CONFIG = {
  entityName: 'RegisterPerProperty',
  localizationKey: 'Planning::Entity.RegisterPerProperty',
  fields: REGISTERPERPROPERTY_FIELDS,
  permission: 'PlanningLocation.RegisterPerProperties',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Location + MENU_NAME_SUFFIX,
};
